module.exports = __webpack_public_path__ + "media/images/no-image/no-image-pt-4f7b94b0f0a7eb0403f303b74f91fa29.jpg";